import styled from 'styled-components';
import { PromotionItemContent } from '../styled';
import { Typography } from '../../../../../ui/Typography';

export const NotAuthorContent = styled(PromotionItemContent)`
  justify-content: center;
`;

export const ItemTitle = styled(Typography)`
  margin-bottom: 2px;
`;

export const ItemPrice = styled(Typography)`
  color: ${({ theme }) => theme.colors.systemColors.blue};
`;

export const ItemIcon = styled.div`
  align-self: center;

  svg {
    margin-top: -3px;
  }
`;
